export enum ApplicationsCourseStatus {
  declined = 'declined',
  waiting = 'waiting',
  accepted = 'accepted',
  excluded = 'excluded',
  suspended = 'suspended',
}
